import { ReferToneDto } from '../../../dto/refertone/refertonedto';
import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface ReferToneRequest extends APIRequest
{
    getReferToneRequest(): ReferToneDto;
}

export class ReferToneRequestImpl extends APIRequestDtoImpl implements ReferToneRequest
{
    constructor(private referToneData: ReferToneDto)
    {
        super();
    }

    getReferToneRequest(): ReferToneDto
    {
        return this.referToneData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/tune/refertone/refertonerequest.tsx